import { TApplicationState } from '../../types/redux';

export const getBuilderChatButtonClicked = (state: TApplicationState): boolean => !!state.builderChat.isButtonClicked;
